module.exports = __webpack_public_path__ + "static/assets/0d8c7f96a0532a2ac4f6f27cb581caf9.png";